const classifiedKeywords = {
    "variables": {
        "var": "متغير",
        "let": "لنفرض",
        "const": "ثابت",
    },
    "function": {
        "function": "داله",
        "return": "الجواب",
        "yield": "نتيجه",
        "arguments": "مدخلات",
    },
    "boolean": {
        "true": "صحيح",
        "false": "خطا",
    },
    "if": {
        "if": "اذا",
        "else": "والا",
    },
    "loops": {
        "for": "",
        "of": "من",
        "in": "داخل",
        "while": "مادام",
        "do": "افعل",
        "break": "قف",
        "continue": "استمر",
    },
    "switch": {
        "switch": "حالات",
        "case": "حاله",
        "default": "افتراضي",
    },
    "try": {
        "try": "حاول",
        "catch": "التقط",
        "finally": "نهائي",
        "throw": "اخبر",
    },
    "oop": {
        "class": "",
        "this": "",
        "new": "انشى",
        "null": "",
        "extends": "",
        "super": "",
        "instanceof": "",
        "static": "",
    },
    "other": {
        "delete": "",
        "typeof": "",
        "goto": "",
        "eval": "",
        "with": "",
        "debugger": "تفحص",
        "import": "استورد",
        "export": "اصدر",
        "as": "الى",
        "from": "من"
    },
    "safety": {
        "package": "",
        "interface": "",
        "implements": "",
        "private": "",
        "protected": "",
        "public": "",
        "native": "",
        "synchronized": "",
        "throws": "",
        "transient": "",
        "void": "",
        "volatile": "",
        "enum": "",
        "final": "",
    },
    "types": {
        "float": "عشري",
        "int": "رقم",
        "long": "",
        "char": "",
        "short": "",
        "double": "",
        "byte": "",
        "boolean": "",
    },
};
const classifiedDictionary = {
    "generic": {
        "console": "اطبع",
        "undefined": "مجهول",
        "NaN": "لارقمي",
        "Infinity": "لانهائي",
        "JSON": "جيسون",
        "prototype": "",
        "constructor": "",
        "eval": "",
        "window": "",
        "document": "",
        "fetch": "حمل",
        "json": "الى_جيسون"

    },
    "functions": {
        "setTimeout": "",
        "clearTimeout": "",
        "setInterval": "",
        "clearInterval": "",
        "parseFloat": "",
        "parseInt": "",
        "isFinite": "",
        "isNaN": "رقمي",
        "decodeURI": "",
        "decodeURIComponent": "",
        "encodeURI": "",
        "encodeURIComponent": "",
        "escape": "",
        "unescape": "",
        "require": "",

    },
    "classes": {
        "Object": "",
        "Function": "",
        "Boolean": "",
        "Number": "",
        "Date": "",
        "String": "",
        "RegExp": "",
        "Array": "",
        "Buffer": "",
        "Set": "",
        "Map": "",
        "Promise": "",
        "Math": "",
    },
    "console": {
        "error": "خلل",
        "log": "نص",
        "clear": "",
        "debug": "",
        "info": "معلومة",
        "trace": "",
        "warn": "تنبية",
        "table": "جدول"
    },
    "json": {
        "stringify": "",
        "parse": "",
    },
    "promise": {
        "reject": "رفض",
        "resolve": "قبول",
        "all": "كل",
        "race": "تعارض",
        "then": "ثم",
        "catch": "فشل",
    },
    "math": {
        "abs": "",
        "ceil": "",
        "floor": "",
        "max": "",
        "min": "",
        "pow": "",
        "random": "عشوائي",
        "round": "",
        "sqrt": "",
    },
    "array": {
        "concat": "جمع",
        "length": "طول",
        "entries": "",
        "filter": "صفي",
        "find": "اوجد",
        "forEach": "لكل",
        "includes": "يحتوي",
        "indexOf": "",
        "join": "",
        "keys": "",
        "lastIndexOf": "",
        "map": "نقح",
        "pop": "",
        "push": "",
        "reduce": "",
        "reverse": "",
        "shift": "הסט",
        "slice": "",
        "some": "",
        "sort": "رتب",
        "splice": "",
        "toString": "",
        "unshift": "",
    },
    "string": {
        "charAt": "",
        "charCodeAt": "",
        "endsWith": "",
        "match": "",
        "repeat": "",
        "replace": "",
        "search": "",
        "split": "",
        "startsWith": "",
        "substr": "",
        "substring": "",
        "trim": "",
    },
};

function flattenObject(obj) {
    const result = {};
    for (const k in obj) {
        const nested = obj[k];
        for (const key in nested) {
            const value = nested[key];
            result[key] = value;
        }
    }
    return result;
}

export default {
    keywords: flattenObject(classifiedKeywords),
    dictionary: flattenObject(classifiedDictionary),
    chars: {
        "ا": "a",
        "ب": "b",
        "ج": "g",
        "د": "d",
        "ه": "h",
        "ו": "v",
        "ז": "z",
        "ח": "h",
        "ט": "t",
        "י": "i",
        "כ": "k",
        "ל": "l",
        "מ": "m",
        "נ": "n",
        "ס": "s",
        "ע": "a",
        "פ": "p",
        "צ": "z",
        "ק": "k",
        "ר": "r",
        "ש": "sh",
        "ת": "t",
        "ן": "n",
        "ם": "m",
        "ך": "ch",
        "ף": "f",
        "ץ": "z"
    },
    quotes: [
        '"',
        "'",
        "״",
        "׳",
    ],
    classifiedKeywords,
    classifiedDictionary,
}
